import ApiService from "../../services/api.service";
import { Notify } from 'quasar';

export const apiMarcheInclusion = {
  state: {
    marcheResults: [],
    marcheDetail: null,
  },
  mutations: {
    setMarcheResults(state, results) {
      state.marcheResults = results;
    },
    setMarcheDetail(state, detail) {
      state.marcheDetail = detail;
    }
  },
  actions: {
    // Search structures via backend proxy: /marche-inclusion/search?q=...
    async fetchMarcheSearch(context, { q, page = 1 }) {
      if (!q || q.length < 2) {
        context.commit('setMarcheResults', []);
        return;
      }

      try {
        const url = `/marche-inclusion/search?q=${encodeURIComponent(q)}&page=${page}`;
        const response = await ApiService.getRequest(url);
        context.commit('setMarcheResults', response.data);
      } catch (error) {
        console.error('Marche search error', error);
        Notify.create({ message: "Erreur lors de la recherche dans l'annuaire LeMarche.", color: 'negative' });
      }
    },

    // Get one structure by id via proxy: /marche-inclusion/structure/{id}
    async fetchMarcheStructure(context, id) {
      if (!id) return;
      try {
        const url = `/marche-inclusion/structure/${encodeURIComponent(id)}`;
        const response = await ApiService.getRequest(url);
        context.commit('setMarcheDetail', response.data);
      } catch (error) {
        console.error('Marche structure error', error);
        Notify.create({ message: "Erreur lors de la récupération de la structure.", color: 'negative' });
      }
    }
  },
  getters: {
    getMarcheResults(state) {
      return state.marcheResults;
    },
    getMarcheDetail(state) {
      return state.marcheDetail;
    }
  }
}
